export const isStaging = process.env.REACT_APP_ENV === "staging";
